import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import withPermissions from "../../components/WithPermissions";
import PageHeader from "../../components/PageHeader";
import mainHelper, { apiCall } from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
class TypeAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: {
                name: '',
                save_parasut: ''
            },
            loading: false
        }
    }

    handleChange = (e) => {
        const { id, type, checked, value } = e.target;
        const inputValue = type === 'checkbox' ? checked : value;
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                [id]: inputValue
            }
        }));
    }
    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        const { formData } = this.state;
        const typeFormData = new FormData();
        Object.keys(this.state.formData).forEach(key => {
            typeFormData.append(key, formData[key]);
        });
        try {
            const response = await apiCall('business/operation/type/add', 'post', typeFormData);
            this.setState({ loading: false });
            mainHelper.toastMessage(response.status, response.message)
        } catch (e) {
            this.setState({ loading: false });
        }

    }
    render() {
        const { loading } = this.state;
        const { userPermissions } = this.props;
        const userHasNewTypePermission = userPermissions.includes('new setting service type');
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}>
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Servis tipi ekle"
                            Breadcrumb={[
                                { name: "Servis tipleri", navigate: "operation-types" },
                                { name: "Yeni servis tipi", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <div className="card">
                                <form onSubmit={this.handleSubmit}>
                                    <div className="body">
                                        <div className="row clearfix justify-content-center">
                                            <div className="col-lg-6 col-md-12">
                                                <div className="form-group">
                                                    <small>ServiceZone içerisinde servis tipleri, her bir işletmenin
                                                        sunduğu hizmetleri kategorize ederek daha iyi yönetim ve
                                                        raporlama imkanı sağlar. Servis tipleri, farklı hizmet
                                                        türlerini tanımlamanıza ve her servisin niteliğine göre
                                                        işlem yapmanıza olanak tanır. Bu sayede, hangi tür
                                                        hizmetlerin daha sık kullanıldığını, hangi alanlarda
                                                        iyileştirmeler yapılabileceğini ve müşterilere daha iyi
                                                        hizmet sunmak için hangi servislerin öne çıkarılması
                                                        gerektiğini kolayca belirleyebilirsiniz.</small>
                                                </div>
                                                <div className="form-group">
                                                    <input
                                                        id="name"
                                                        className="form-control"
                                                        placeholder="Servis tipi adı"
                                                        type="text"
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                                {/*<div className="form-group">
                                                        <div className="fancy-checkbox">
                                                            <label htmlFor="save_parasut"
                                                                   className="font-weight-bold text-cyan">

                                                                <input
                                                                    id="save_parasut"
                                                                    type="checkbox"
                                                                    checked={this.state.formData.save_parasut}
                                                                    onChange={this.handleChange}
                                                                />
                                                                <span>Paraşütte Ürün/Hizmet Kaydı Oluştur</span>
                                                            </label>
                                                        </div>
                                                    </div>*/}
                                            </div>
                                        </div>

                                    </div>
                                    <div className="body">
                                        <div className="row clearfix justify-content-center">
                                            <div className="col-lg-6 col-md-12">
                                                {loading ? (
                                                    <button className="btn btn-outline-primary btn-block"
                                                        disabled={true}
                                                        style={{ textAlign: "-webkit-center" }}>
                                                        Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'}
                                                            height={'24px'}
                                                            color="#268bd2"></ReactLoading>
                                                    </button>
                                                ) :
                                                    <button disabled={!userHasNewTypePermission}
                                                        className="btn btn-outline-primary btn-block"
                                                        type="submit">
                                                        Kaydet
                                                    </button>}

                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ ioTReducer }) => ({
    isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(TypeAdd)));
